export const SET_SESSIONS_LIST = 'sessions/SET_SESSIONS_LIST'
export const SET_MANAGE_SESSION = 'sessions/SET_MANAGE_SESSION'
export const UPDATE_ACTIVE_SESSION = 'sessions/UPDATE_ACTIVE_SESSION'
